import React,{useState, useEffect}  from 'react';
import {Card,Button} from 'react-bootstrap';
import Sides from '../Bars/Diffjvscs';


import { Helmet } from "react-helmet";
function Jscif(){


    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    


return(
    <div >
        <Sides/>
        <Helmet>
 
        <title>Difference Between Java and C# If tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and C# If tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, java tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,Csharp(C#),Java,Python,if,tutorial for begineers,Difference Between Java and C#,Difference between program and code,java tutorial for begineers,C# tutorial for begineers,java tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs c#,java vs Python,Difference Between Java and C# if" />
<link rel="canonical" href="https://www.codeexampler.com/java-vs-csharp-if" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java vs CSharp(C#) if</h1>
    <div className="first">
        <a href="/java-vs-csharp-basic">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para"> <span className="bold">If statement: </span>If the statement is used for making a decision.If and else can be a block</p>

<h2 className="mt-4 mh2">
Syntax of Java if statement:
</h2>
<Card className='inde' border='primary m-4'>
    <Card.Header as="h5">Java if statement syntax
        </Card.Header>
    <Card.Body>
        <Card.Text>
            if (condition) statement;<br/>
            Or <br />
            if(condition)<br/>
            &#123;<br/>
            body<br/>
            &#125;<br/>
        </Card.Text>
    </Card.Body>
</Card>

<h2 className="mt-4 mh2">
Syntax of c# if statement:
</h2>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">if syntax in c#</Card.Header>
  <Card.Body>
    <Card.Text>
    <p>if (condition)<br/>
    &#123;<br />
         Statement;<br/>
         &#125;<br />
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h2 className="mt-4 mh2">
Java if Statement Example:</h2>

<Card className='inde' border='primary m-4'>
    <Card.Header as="h5">Q-Write a program to input a number and check this number is more than or equal to 100 in Java if statement?
         </Card.Header>
        <Card.Body>
         <Card.Text>
         public class if_example &#47;&#47; class is a keyword<br />
             &#123;<br />
         public static void main(String[] args)<br />
         &#123;<br />
             int a=500;<br />
            if(a&#62;100)<br />
        System.out.println("a is greater");<br />
                &#125;<br />
                &#125;<br />
                    </Card.Text>
                </Card.Body>
                <Card.Footer>Output-<br/>a is greater</Card.Footer>
            </Card>

            <h2 className="mt-4 mh2">
C# if Statement Example:</h2>

            <Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a program to input a number and check this number is more than or equal to 100 in C#?
</Card.Header>
  <Card.Body>
    <Card.Text>
    <p>
    namespace if<br/>
    &#123;<br/>
    class Program<br/>
    &#123;<br/>
        static void Main(string[] args)<br/>
 &#123;<br/>
 int a;<br/>
 Console.WriteLine("enter a number");<br/>
 a = Convert.ToInt32(Console.ReadLine());<br/>
 if(a &#62;= 100)<br/>
&#123;<br/>
Console.WriteLine("this no is greater than 100");<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
&#125;
</p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output- <br/>enter a number<br/>101 <br/><br/>Answer-<br/> this no is greater than 100</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
      
<div className="back">
        <a href="/java-vs-csharp-basic">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Jscif;